import { render, staticRenderFns } from "./ProductContentsDialog.vue?vue&type=template&id=7037150a&scoped=true&"
import script from "./ProductContentsDialog.vue?vue&type=script&lang=ts&"
export * from "./ProductContentsDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ProductContentsDialog.vue?vue&type=style&index=0&id=7037150a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7037150a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VDialog})
